import http from 'services/utils/http';

class VerifyToken {
    // eslint-disable-next-line class-methods-use-this
    verifyToken(token) {
        if (token) {
            const apiUrl = `/partners/signUp/verification?token=${token}`;
            return http.post(apiUrl, { token }, false);
        }
        return Promise.reject(new Error('Missing Fields. Please check your details'));
    }
}

export default new VerifyToken();
